var React = require('react');

function MoneyBagDollar (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M13.574,12.75H11.541a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H10.574","key":1}),React.createElement("line",{"className":"a","x1":"12.074","y1":"12.75","x2":"12.074","y2":"12","key":2}),React.createElement("line",{"className":"a","x1":"12.074","y1":"19.5","x2":"12.074","y2":"18.75","key":3}),React.createElement("line",{"className":"a","x1":"6.824","y1":"8.25","x2":"17.324","y2":"8.25","key":4}),React.createElement("path",{"className":"a","d":"M15.63,5.036,17.068,2.16a.75.75,0,0,0-1.006-1.006l-1.9.948a.75.75,0,0,1-.959-.255L12.7,1.084a.75.75,0,0,0-1.248,0l-.509.763a.749.749,0,0,1-.959.255L8.087,1.154A.751.751,0,0,0,7.08,2.16L8.49,4.98","key":5}),React.createElement("path",{"className":"a","d":"M7.237,10.5l-2.76,3.2a5.932,5.932,0,0,0,4.7,9.549h5.79a5.932,5.932,0,0,0,4.7-9.549l-2.76-3.2","key":6})]);
}

MoneyBagDollar.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = MoneyBagDollar;

MoneyBagDollar.default = MoneyBagDollar;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/money-bag-dollar.svg
// module id = 1075
// module chunks = 0